import API from '../../../../network/dashboardAPI';

export const fetchStocks = async (page = 1, limit = 10, orderField, orderType, filters) => {
    try {
        const postData = { page, limit, orderField, orderType, filters };
        const response = await API.getStockManagement(postData);
        return response.json();
    } catch (error) {
        console.error("Error fetching stocks:", error);
        return { data: [], error: error.message || "Failed to fetch stocks" };
    }
};

export const updateStock = async (stock_id, available_quantity = null, warehouse_id = null, location_name = null) => {
	try {
		const postData = {stock_id, available_quantity, warehouse_id, location_name};
		const response = await API.updateStockPerId(postData);
		return response.json();
	} catch (error) {
		console.error("Error updating stock:", error);
		return {data: [], error: error.message || "Failed to update stock"};
	}
};

export const uploadStocks = async (postData) => {
    try {
        const response = await API.uploadStockManagement(postData);
        return response.json();
    } catch (error) {
        console.error("Error uploading stocks:", error);
        return { data: [], error: error.message || "Failed to upload stocks" };
    }
};

export const addStock = async (postData) => {
	try {
		const response = await API.addStockManagement(postData);
		return response.json();
	} catch (error) {
		console.error("Error adding stock:", error);
		return {data: [], error: error.message || "Failed to add stock"};
	}
};